"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withAnalytics = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactGa = _interopRequireDefault(require("react-ga"));

var _reactRouterDom = require("react-router-dom");

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var withAnalytics = function withAnalytics(Component) {
  var WithAnalytics =
  /*#__PURE__*/
  function (_React$PureComponent) {
    _inherits(WithAnalytics, _React$PureComponent);

    function WithAnalytics() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, WithAnalytics);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WithAnalytics)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "trackPage", function () {
        var url = _this.props.match.url;

        if (url && _helpers.isProduction) {
          _reactGa.default.ga('send', 'pageview', url);
        }
      });

      return _this;
    }

    _createClass(WithAnalytics, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.trackPage();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(nextProps) {
        var currentPage = this.props.match.url;
        var nextPage = nextProps.match.url;

        if (currentPage !== nextPage) {
          this.trackPage();
        }
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement(Component, this.props);
      }
    }]);

    return WithAnalytics;
  }(_react.default.PureComponent);

  _defineProperty(WithAnalytics, "propTypes", {
    match: _propTypes.default.shape({
      url: _propTypes.default.string
    }).isRequired
  });

  return (0, _reactRouterDom.withRouter)(WithAnalytics);
};

exports.withAnalytics = withAnalytics;